import { COURSE_HREF } from '@/lib/marketingCtas';
import { DifficultyLadder } from '../home/DifficultyLadder';
import { HomeClose } from '../home/HomeClose';
import { HomeHero } from '../home/HomeHero';
import { StraightAnswers } from '../home/StraightAnswers';
import { DoorsSection } from '../home/DoorsSection';
import { TutoringRealScreen } from '../home/TutoringRealScreen';

const SITE = 'https://mentaratutors.com';
const TITLE = 'Free SAT Course & Online Tutoring | Mentara';
const DESCRIPTION =
  'A free SAT course that starts with a diagnostic and aims every practice set at your weak spots. No account needed. Add a 1-on-1 tutor when you want one.';

// Spec 010 §5.6: Organization + Course (free), provider Mentara.
const STRUCTURED_DATA = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Mentara',
    url: SITE,
    logo: `${SITE}/logos/mentara-full-light.png`,
    description: 'The free SAT course, plus 1-on-1 online tutoring when you want it.',
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: 'Free SAT Course',
    description:
      'A diagnostic finds your weak spots, every practice set aims there, and each area turns green once you have proved it.',
    url: `${SITE}${COURSE_HREF}`,
    isAccessibleForFree: true,
    provider: { '@type': 'Organization', name: 'Mentara', url: SITE },
  },
];

export function HomePage() {
  return (
    <>
      <title>{TITLE}</title>
      <meta name="description" content={DESCRIPTION} />
      <meta
        name="keywords"
        content="free SAT course, SAT diagnostic, SAT practice, online tutoring, 1-on-1 tutors, test prep, tutoring platform"
      />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE}/`} />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={DESCRIPTION} />
      <meta property="og:image" content={`${SITE}/logos/mentara-full-light.png`} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`${SITE}/`} />
      <meta property="twitter:title" content={TITLE} />
      <meta property="twitter:description" content={DESCRIPTION} />
      <meta property="twitter:image" content={`${SITE}/logos/mentara-full-light.png`} />

      <link rel="canonical" href={`${SITE}/`} />

      {STRUCTURED_DATA.map((entry) => (
        <script key={entry['@type']} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(entry) }} />
      ))}

      <div className="bg-background">
        <HomeHero />
        <DifficultyLadder />
        <StraightAnswers />

        {/* Everything above is the free SAT course. Below the band: the people, for when you want one. */}
        <div className="mt-6 border-y bg-muted/40 lg:mt-10" data-testid="beyond-course">
          <TutoringRealScreen />
          <div className="border-t border-border/70">
            <DoorsSection />
          </div>
        </div>
        <HomeClose />
      </div>
    </>
  );
}
